import React, { Component } from 'react'
import backtop from '../../assets/images/newui/back-to-top.svg'
import { connect } from 'react-redux';
import './FooterContainer.less'

class FooterContainer extends Component {

    onBackToTopClick = () => {
        this.props.topclick();
    }

    render() {
        return (
            <section className="footer-section">
                <img src={backtop} className="back-to-top" onClick={this.onBackToTopClick}></img>
                <div className="content-panel">
                    <div className="left-panel">
                        © {(new Date).getFullYear()} Syndafy Inc.
                                </div>
                    <div className="right-panel">
                        <div className="links">
                            {/* <a href="/contact-us">Contact Us</a> */}
                            {/* <span> | </span> */}
                            <a href={this.props.seller.disableRedirection ? "javascript:void(0)" : "/privacy-policy" } >Privacy Policy</a>
                            <span> | </span>
                            <a href={this.props.seller.disableRedirection ? "javascript:void(0)" : "/terms-of-use"} >Terms of Use</a>
                        </div>
                    </div>
                    {/*<div className="right-panel">
                        <div className="social">
                            <a href="#"><img src={fb}></img></a>
                            <a href="#"><img src={twitter}></img></a>
                            <a href="#"><img src={insta}></img></a>
                            <a href="#"><img src={youtube}></img></a>
                        </div>
                    </div>*/}
                </div>
            </section>
        )
    }
}

function mapStateToProps({ auth, reducer, appView, seller }) {
    // Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        seller: seller
    }
}

export default connect(mapStateToProps, null)(FooterContainer);

